import tippy from 'tippy.js';

document.addEventListener('DOMContentLoaded', () => {
  const tippyElements = Array.from(document.querySelectorAll('[tippy]'));

  tippyElements.forEach((item) => {
    const content = item.getAttribute('tippy');

    tippy(item, {
      content,
    });
  });
});
